module.exports = __webpack_public_path__ + "static/media/userpicAnonymous1.f698bb5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/userpicAnonymous1.svg
// module id = 522
// module chunks = 0